import { Button, CircularProgress, Stack } from '@mui/material';
import { useHavePermission } from '@/hooks';
import { Permissions } from '@/types';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';

type Props = {
  loading: boolean;
  onUploadClick: () => void;
  onCaptureClick?: () => Promise<void>;
  location?: string;
};

export const MediaActionButtons = ({ loading, onUploadClick, onCaptureClick, location }: Props) => {
  const userCanUploadMedia = useHavePermission(Permissions.CREATE_UPLOAD_MEDIA);

  return (
    <Stack direction="row" alignItems="start" gap={1.5}>
      {userCanUploadMedia && (
        <Button
          variant="contained"
          size="small"
          disabled={loading}
          onClick={onUploadClick}
          id={`${location}-upload-media-button`}
          startIcon={
            loading ? (
              <CircularProgress size={12} />
            ) : (
              <AbyssIcon iconName="arrow-up-light" size="md" />
            )
          }
        >
          {loading ? 'Uploading' : 'Upload'}
        </Button>
      )}

      <Button
        size="small"
        disabled={loading}
        onClick={onCaptureClick}
        variant="contained"
        id={`${location}-capture-view-button`}
        startIcon={
          loading ? (
            <CircularProgress size={12} />
          ) : (
            <AbyssIcon iconName="screenshot-light" size="md" />
          )
        }
      >
        {loading ? 'Capturing' : 'Capture View'}
      </Button>
    </Stack>
  );
};
